module.exports = __webpack_public_path__ + "images/licensed-header.e8f4bc0090bb972fcb70b05f477d3dc5.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/licensed-header.jpg
// module id = 1010
// module chunks = 0